import React, { useState } from "react";
import { required, } from "../../utils/validation";
const SelectDropdown = (props) => {
    const [selectOption, setselectOption] = useState();
    const [value, setValue] = React.useState(props.defaultValue || "");
    // const handleMouseOut = (e: any) => {
    //     if (props.onMouseOut) {
    //       e.currentTarget.blur();
    //       props.onMouseOut(e.target.value);
    //     }
    //   };
    function isRequired(value) {
        return !props.required || (props.required && !!required(value));
    }
    function handleBlur(e) {
        setFocusClass("");
        let errorObj = {};
        if (props.required) {
            errorObj = Object.assign(Object.assign({}, errorObj), { required: isRequired(value) });
        }
        props === null || props === void 0 ? void 0 : props.onBlur(errorObj, e);
    }
    React.useEffect(() => {
        if (props.defaultValue !== undefined && value !== props.defaultValue) {
            setValue(props.defaultValue);
        }
    }, [props.defaultValue]);
    const [focusClass, setFocusClass] = React.useState("");
    return (React.createElement("div", { className: "col" },
        React.createElement("div", { className: props.className },
            React.createElement("div", { className: props.placeholderClassName +
                    (props.errorText ? " error" : focusClass) }, value === "" && props.lable && (React.createElement(React.Fragment, null,
                React.createElement("label", { htmlFor: props.id }, props.placeholder),
                props.required && React.createElement("span", { className: "star" }, "*")))),
            React.createElement("select", { className: "form-control", defaultValue: value, id: props.id, name: props.name, onChange: props.onChangeEvent, onFocus: () => setFocusClass(" focus"), required: props.required, 
                //    onMouseOut={handleMouseOut}
                onBlur: (e) => handleBlur(e) }, props.dropdownOptions.map((option, index) => option.value ? (React.createElement("option", { key: index, value: option.value }, option.display)) : (React.createElement(React.Fragment, null)))),
            React.createElement("span", { className: props.downarrow }))));
};
export default SelectDropdown;
